// extracted by mini-css-extract-plugin
export default {"student_count":"StudentCount_student_count__wFJsp"};